import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getFormSyncErrors, getFormValues} from 'redux-form';
import moment from 'moment';
import MachineForm from './MachineForm';
import MachineViewPage from './view/MachineViewPage';
import PreviewModal from '../common/PreviewModal';
import * as submitButtonActions from '../../actions/submit/submitButtonActions';
import * as currencyActions from '../../actions/currencyActions';
import * as priceTypeActions from '../../actions/priceTypeActions';
import * as contactPersonListActions from '../../actions/contactPersonListActions';
import * as contactPersonModalActions from '../../actions/contactPersonModalActions';
import * as categoriesActions from '../../actions/machines/machineCategoriesActions';
import * as machinesActions from '../../actions/machines/machinesActions';
import * as modalActions from '../../actions/common/modalActions';
import * as vimeoActions from '../../actions/vimeoActions';
import ContactPersonModal from '../contact-person/ContactPersonModal';
import {toastr} from 'react-redux-toastr';
import MachineFormSerializer from "../../services/MachineFormSerializer";
import {DATE_TIME_FORMAT} from "../helpers/DateHelper";
import {FormattedMessage, injectIntl} from 'react-intl';
import {messages} from  '../common/Translations';
import * as pendingPageActions from '../../actions/pendingPageActions';
import WithResolvedPromises from "../common/WithResolvedPromises";
import Placeholder from "../Placeholder";
import PlaceholderError from "../common/PlaceholderError";
import ResetFormModal from "../ResetFormModal";

class MachineFormContainer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.onModalClick   = this.onModalClick.bind(this);
        this.submit         = this.submit.bind(this);
        this.handleReset    = this.handleReset.bind(this);
        this.isUpdate       = this.isUpdate.bind(this);
//        this.onDateChange = this.onDateChange.bind(this);

        this.state = {
            uploadedImages: []
        };

        this.actions = this.getRequiredActions();
    }

    getRequiredActions() {
        let actions = [
            this.props.actions.loadContactPersons(this.props.user.company.id),
            this.props.actions.loadCategories(this.props.user.company.portalId)
        ];

        if(this.isUpdate()) {
            actions.push(this.props.actions.getMachine(this.props.match.params.id));
        } else {
            actions.push(this.props.actions.resetMachine());
        }

        return actions;
    }

    componentWillReceiveProps(nextProp) {

        if(
            nextProp.formValues.vimeoId !== '' &&
            this.props.formValues.vimeoId !== nextProp.formValues.vimeoId &&
            this.props.match.params.id
        ) {
            let vimeoId = nextProp.formValues.vimeoId;
            this.props.actions.updateMachineVimeo(this.props.match.params.id, {vimeoId});
        }

        // if form not ready yet or we don't need to load modal yet
        if(!Object.keys(this.props.formValues).length) {
            this.props.actions.hidePreviewModal();
        }

        if(nextProp.showPreviewModal && Object.keys(this.props.errors).length) {
            this.props.actions.showSweetAlertModal(this.props.intl.formatMessage(messages.mustFillRequiredFields));
            this.props.actions.hidePreviewModal();
        }

        if(!nextProp.formValues
            || !Object.keys(nextProp.formValues).length
            || JSON.stringify(this.props.formValues.images) === JSON.stringify(nextProp.formValues.images)
        ) {
            return;
        }

        let imagePromises = nextProp.formValues.images.map(image => {
            return new Promise(function(resolve, reject){
                let reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = function(e) {
                    resolve(reader.result);
                };
            });
        });

        if(imagePromises.length) {
            Promise.all(imagePromises)
                .then(image => image)
                .then(images => this.setState({uploadedImages: images}));
        }
        else {
            this.state.uploadedImages = [];
        }
    }

    submit(formFields) {
        if(formFields.vimeoId) {
            this.props.actions.updateVimeoVideo(formFields.vimeoId, {name: formFields.vimeoName || formFields.heading, description: formFields.vimeoDescription})
                .then(() => {
                    this.sendForm(formFields);
                });
        } else {
            this.sendForm(formFields);
        }
    }

    sendForm(formFields) {
        let fields = MachineFormSerializer.serialize({...formFields});
        this.props.actions.showSubmitButtonSpinner();
        if(this.isUpdate()) {
            this.props.actions.updateMachine(fields, this.props.match.params.id).then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                this.redirect();
                toastr.success(this.props.intl.formatMessage(messages.advertisementIsUpdated));
            }).catch((e) => {
                this.props.actions.hideSubmitButtonSpinner();
            });
        } else {
            this.props.actions.saveMachine(fields).then(() => {
                this.props.actions.hideSubmitButtonSpinner();
                toastr.success(this.props.intl.formatMessage(messages.advertisementIsCreated));
                this.redirect();
            }).catch(() =>
                this.props.actions.hideSubmitButtonSpinner());
        }
    }

    isUpdate() {
        return this.props.match.params.hasOwnProperty('id');
    }

    confirmReset() {
        this.props.actions.hideResetFormModal();
        this.redirect();
    }

    handleReset() {
        this.props.actions.showResetFormModal();
    }

    redirect() {
        this.context.router.history.push('/maskine');
    }

    onModalClick() {
        this.props.actions.showContactPersonModal();
    }

    onDateChange(dateField, moment) {
//        console.log(dateField, moment);
    }

    getPreviewModalContent() {
        let {
            formValues,
            errors,
            contactPersons,
            currencies,
            priceTypes,
        } = this.props;

        // if form not ready yet or we don't need to load modal yet
        if(!Object.keys(formValues).length || Object.keys(errors).length) {
            return null;
        }

        let categories = [];
        if(formValues.categoryIds) {
            categories = formValues.categoryIds.map((item, key) => {
                return {name: item.label};
            });
        }

        let images = formValues.defaultImages.slice();
        this.state.uploadedImages.forEach(src => images.push({path: src}));

        let currency = formValues.currencyId
            ? currencies.find(currency => +currency.id === +formValues.currencyId)
            : currencies[0];

        let priceType = formValues.priceTypeId
            ? priceTypes.find(priceType => +priceType.id === +formValues.priceTypeId)
            : priceTypes[0];

        let contactPerson = (+formValues.contactPersonId)
            ? contactPersons.find(contactPerson => +contactPerson.id === +formValues.contactPersonId)
            : null;

        return <MachineViewPage
            machine={{
                publishedAt: moment(formValues.startDate, DATE_TIME_FORMAT).unix(),
                title: formValues.heading,
                description: formValues.description,
                videoLink: formValues.youtubeId,
                publicationType: formValues.sellType,
                isUsed: (formValues.isUsed === 'used'),
                priceAmount: formValues.amount,
                manufacturer: formValues.producer,
                model: formValues.model,
                year: formValues.amount,
                link: formValues.referenceNumber,

                images,
                categories,
                currency,
                priceType,
                contactPerson,

            }}
        />
    }

    render() {
        return (
            <WithResolvedPromises preloaderComponent={Placeholder} promises={this.actions} errorComponent={PlaceholderError}>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1 className="mb-3">{this.props.intl.formatMessage(messages.machineFormTitle)}</h1>
                                <MachineForm
                                    initialValues={this.props.machine}
                                    enableReinitialize={true}
                                    keepDirtyOnReinitialize={true}
                                    contactPersons={this.props.contactPersons}
                                    currencies={this.props.currencies}
                                    categories={this.props.categories}
                                    handleModalClick={this.onModalClick}
                                    onSubmit={this.submit}
                                    handleReset={this.handleReset}
                                    isUpdate={this.isUpdate}
                                    onDateChange={this.onDateChange}
                                    showPreviewModal={this.props.actions.showPreviewModal}
                                />
                                <ContactPersonModal/>
                            </div>
                        </div>
                    </div>
                </div>
                <PreviewModal>
                    {this.getPreviewModalContent()}
                </PreviewModal>
                <ResetFormModal
                    modalTitle={this.props.intl.formatMessage(messages.resetModalTitle)}
                    modalContent={
                        <p>
                            <FormattedMessage
                                id="reset.modal.message"
                                defaultMessage="Are you sure, you want to cancel? All of your alterations will be lost."
                            />
                        </p>}
                    confirmText={this.props.intl.formatMessage(messages.buttonYes)}
                    closeText={this.props.intl.formatMessage(messages.buttonNo)}
                    handleConfirm={() => {this.confirmReset()}}
                />
            </div>
            </WithResolvedPromises>

        );
    }
}

MachineFormContainer.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {

    let errors      = Object.assign({}, getFormSyncErrors('machine')(state));
    let formValues  = Object.assign({}, getFormValues('machine')(state));
    let machine     = MachineFormSerializer.unserialize(state.machine);

    return {
        machine: machine,
        contactPersons: state.contactPersons,
        categories: MachineFormSerializer.unserializeCategories(state.machineCategories),
        currencies: state.currencies,
        priceTypes: state.priceTypes,
        user: state.user,
        showPreviewModal: state.showPreviewModal,
        errors,
        formValues,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...machinesActions,
            ...contactPersonListActions,
            ...contactPersonModalActions,
            ...categoriesActions,
            ...currencyActions,
            ...priceTypeActions,
            ...modalActions,
            ...submitButtonActions,
            ...vimeoActions,
            ...pendingPageActions,
        }, dispatch)
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(MachineFormContainer));





// WEBPACK FOOTER //
// ./web/src/components/machines/MachineFormContainer.jsx